import Image from 'next/image';
import Link from 'next/link';

import { CloudinaryImageViewModel } from '@api/v3';
import Typography from '@components/Typography';
import { productImpression } from '@utils/newDataLayer/productImpression';

import { ImageWrapper, Label, Wrapper } from './style';

type Props = {
  image: CloudinaryImageViewModel;
  label: string;
  url?: string;
  type?: string;
};
const CardItem = ({ image, label, url, type }: Props) => {
  return (
    <Link
      href={url ?? ''}
      rel='noopener noreferrer'
      prefetch={false}
      onClick={() => {
        productImpression({
          item_list_location: 'Popüler Turlar',
          item_list_id: label,
          type: type === 'ship' ? 'ship' : 'tour',
        });
      }}
    >
      <Wrapper>
        <ImageWrapper>
          <Image
            src={image?.url ?? ''}
            alt={image?.alt ?? 'setur'}
            layout='fill'
          />
        </ImageWrapper>
        <Label>
          <Typography variant='caption2' weight='SemiBold' color='D400'>
            {label}
          </Typography>
        </Label>
      </Wrapper>
    </Link>
  );
};

export default CardItem;
